'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = uuid;
// https://gist.github.com/LeverOne/1308368 (DO WTF YOU WANT TO PUBLIC LICENSE)
function uuid(a, b) {
  for (b = a = ''; a++ < 36; b += a * 51 & 52 ? (a ^ 15 ? 8 ^ Math.random() * (a ^ 20 ? 16 : 4) : 4).toString(16) : '-') {}return b;
} // eslint-disable-line
//# sourceMappingURL=uuid.js.map